import { createLucideIcon } from "lucide-react";

export const Briefcase = createLucideIcon(
    "Briefcase",
    [
        [
            "path",
            {
                d: "M12 15L12 16.5",
                key: "ojrpmr",
            },
        ],
        [
            "path",
            {
                d: "M16 6L15.9117 5.69094C15.4717 4.15089 15.2517 3.38087 14.7279 2.94043C14.2041 2.5 13.5084 2.5 12.117 2.5H11.883C10.4916 2.5 9.79587 2.5 9.2721 2.94043C8.74832 3.38087 8.52832 4.15089 8.0883 5.69094L8 6",
                key: "1dnu0o",
            },
        ],
        [
            "path",
            {
                d: "M2.84718 10.4431C4.54648 13.6744 8.3792 15 12 15C15.6208 15 19.4535 13.6744 21.1528 10.4431C21.964 8.90056 21.3498 6 19.352 6H4.648C2.65023 6 2.03603 8.90056 2.84718 10.4431Z",
                key: "zft3pq",
            },
        ],
        [
            "path",
            {
                d: "M3 15C3.14932 17.9325 3.30572 19.4716 4.39811 20.4447C5.58274 21.5 7.43054 21.5 11.1261 21.5H12.8739C16.5695 21.5 18.4173 21.5 19.6019 20.4447C20.6943 19.4716 20.8507 17.9325 21 15",
                key: "17w7xi",
            },
        ],
    ],
);
